import { MutableRefObject, useCallback, useContext, useEffect } from 'react';
import { FormFieldValidationContext } from '../../components/form/context/FormFieldValidationContext';
import { AnyHTMLElement } from './types';
import { scrollElementToTop as scrollFormFieldIntoView } from '../../utils/DomUtils';

export type ValidatableFormFieldFocusNamedDependencies = {};

export type ValidatableFormFieldFocusEffectParams = {
  formFieldWrapperElementRef?: MutableRefObject<AnyHTMLElement>;
  formFieldSelector: string;
};

export function useValidatableFormFieldFocus(
  { formFieldSelector, formFieldWrapperElementRef }: ValidatableFormFieldFocusEffectParams,
  namedDependencies: ValidatableFormFieldFocusNamedDependencies = {},
) {
  const validationContext = useContext(FormFieldValidationContext);
  const blurFunction = useCallback(() => {
    validationContext.blur();
  }, [validationContext.blur]);

  useEffect(() => {
    const { isFocused } = validationContext;

    if (!isFocused) {
      return;
    }

    const targetElement: AnyHTMLElement =
      formFieldWrapperElementRef?.current?.querySelector(formFieldSelector);
    targetElement?.focus();
    scrollFormFieldIntoView(targetElement);

    targetElement?.addEventListener('blur', blurFunction);

    return () => {
      const targetElement: AnyHTMLElement =
        formFieldWrapperElementRef?.current?.querySelector(formFieldSelector);
      targetElement?.removeEventListener('blur', blurFunction);
    };
  }, [validationContext.isFocused]);
}
